import Vue from 'vue';
import VueRouter, { Route, RouterOptions } from 'vue-router';
import routes from './routes';
import { store } from '@/store';
import { authService } from '@/service/api/auth.service';
import { storageService } from '@/service/storage/storage.service';
import { DateUtils } from '@/utils/date.utils';
import { activeMenuStorageService } from '@/service/storage/active-menu-storage.service';
import { GEnum } from '@/constants/enum.defination';
import { HeadMenu } from '@/constants/constants';

Vue.use(VueRouter);

const Router = new VueRouter(({
  mode: 'history', //process.env.VUE_APP_ROUTER_MODE,
  base: process.env.VUE_APP_ROUTER_BASE,
  scrollBehavior: () => ({ y: 0 }),
  routes,
} as any) as RouterOptions);

const dispCtrlTypeDeniedRoutes: string[] = [
  "/pages/statistics",            // 統計情報
  "/pages/customCompetency",      // 学校コンピテンシー
  "/pages/customBoxplotSetting",  // 箱ひげ図追加表示設定
];

Router.beforeEach(async (to: Route, _: Route, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Handle login from iGS Dashboard
    const signinToken = to.query['signinToken'] as string;

    if (to.path === '/pages/home') {
      activeMenuStorageService.activeMenu = HeadMenu.Home.menuID;

      if (signinToken && signinToken.length > 0) {
        // IGSユーザログイン時
        const authInfo = await authService.signinForIgsAccount(signinToken);
        storageService.adminAuthToken = authInfo.authToken;
        await store.dispatch('setSchoolYear', DateUtils.currentSchoolYear(new Date()), { root: true });
        await store.dispatch('setAuthInfo', authInfo, { root: true });
        await store.dispatch('setAuthToken', authInfo.authToken, { root: true });
        console.log('signinToken');
        next({ path: '/pages/home' });
      }
    }

    if (!store.getters.isLogined) {
      next({ path: '/signin' });
    } else {
      // Get account and ticket for every request
      // Get remain ticket

      await store.dispatch('fetchAccount');

      // 内田洋行 画面制御タイプが内田洋行タイプであればこのルーティングは許可しない
      if (store.state.account != undefined && store.state.account.dispCtrlType == GEnum.DispCtrlType.Uchida && dispCtrlTypeDeniedRoutes.includes(to.path)) {
        Router.push("/pages/home")
      }

      //await store.dispatch('fetchTicket', undefined, { root: true });
      next();
    }
  } else {
    next();
  }
});

export default Router;
